import { apiCall } from "./service";
import { BASE_URL } from "./URL";
import {getLocalStorage, keys as localStorageKeys} from '../../utils/localStorageUtils';

const baseUrl = `${BASE_URL}Search/`;


const getSearchUrl = (type, searchterm, queryParams) => {
  let url =`${baseUrl}${type}`;

  url += (searchterm ? `?searchTerm=${encodeURIComponent(searchterm)}&` : '?') + buildQueryParams(queryParams);

  return url;
}

const buildQueryParams = (queryObject) => {
  const params = new URLSearchParams();
  for (const key in queryObject) {
    const value = queryObject[key];
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, value);
    }
  }

  return params.toString();
}
export const api = {
  
  Clients(searchTerm, queryParams) {
    return apiCall.get({
      url: `${getSearchUrl("Clients", searchTerm, queryParams)}`,
    });
  },
  Portfolios(searchTerm, queryParams) {
    return apiCall.get({
      url: `${getSearchUrl("Portfolios", searchTerm, queryParams)}`,
    });
  },
  Programs(searchTerm, queryParams) {
    return apiCall.get({
      url: `${getSearchUrl("Programs", searchTerm, queryParams)}`,
    });
  },
  Projects(searchTerm, queryParams) {
    return apiCall.get({
      url: `${getSearchUrl("Projects", searchTerm, queryParams)}`,
    });
  },
  Users(searchTerm, queryParams) {
    if( !queryParams?.clientId && 
        !queryParams?.projectId && 
        !queryParams?.scopeId && 
        !getLocalStorage(localStorageKeys.HAS_DEFAULT_ADMIN_ROLE))
    {
      return Promise.resolve([]);
    }
    return apiCall.pagination({
      url: `${getSearchUrl("Users", searchTerm, queryParams)}`,
    });
  },
  UsersForAssignment(searchTerm, queryParams) {
    if( !queryParams?.clientId && 
        !queryParams?.projectId && 
        !queryParams?.scopeId && 
        !getLocalStorage(localStorageKeys.HAS_DEFAULT_ADMIN_ROLE))
    {
      return Promise.resolve([]);
    }
    return apiCall.pagination({
      url: `${getSearchUrl("users-assignment", searchTerm, queryParams)}`,
    });
  },
  UsersForClientAssignment(clientId,searchTerm) {
    if(!clientId)
    {
      return Promise.resolve([]);
    }

    let searchUrl =`${BASE_URL}Clients/${clientId}/resources_assignment`;
    
    if(searchTerm)
      searchUrl += `?searchTerm=${searchTerm}`;

    return apiCall.pagination({url: searchUrl});
  },
  Scopes(searchTerm, queryParams) {
    return apiCall.get({
      url: `${getSearchUrl("Scopes", searchTerm, queryParams)}`,
    });
  },
  Tasks(searchTerm, queryParams) {
    return apiCall.get({
      url: `${getSearchUrl("Tasks", searchTerm, queryParams)}`,
    });
  },
  ChangeRequests(searchTerm, queryParams) {
    return apiCall.get({
      url: `${getSearchUrl("ChangeRequests", searchTerm, queryParams)}`,
    });
  },
};

export default api;
